import React, { useEffect, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { PaymentMethodSubscription } from '../../../../../interfaces/merchants/resources/books';
import CheckInput, { InputType } from '../../../../../atoms/CheckInput';
import css from './InputPaymentMySubscription.module.scss';

import { BookingPurchaseProductList } from '../BookingPurchaseProductList';

interface Props {
  paymentMethod: PaymentMethodSubscription;
  onSelect: (purchasedSelection: string) => void;
  mySelection?: string;
}

const InputPaymentMySubscription: React.FC<Props> = (props) => {
  const {
    paymentMethod: { purchased_products, products },
    mySelection,
    onSelect,
  } = props;
  const intl = useIntl();

  useEffect(() => {
    if (purchased_products.length !== 0) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }, [onSelect, purchased_products]);

  const handleSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = e;
      onSelect(value);
    },
    [onSelect],
  );

  const isDisplayRetailer = useMemo(
    () => purchased_products.length === 0,
    [purchased_products],
  );

  return (
    <div className={css.InputPaymentMySubscription}>
      {purchased_products.map((p) => (
        <div key={p.public_id} className={css.availableSubscriptionWrap}>
          <CheckInput
            type={InputType.Radio}
            value={p.public_id}
            checked={mySelection === p.public_id.toString()}
            // @ts-expect-error strictFunctionTypes
            onChange={handleSelect}
            name="payment-subscription"
            disabled={!p.available}
          >
            {p.available && p.booking_limit.limited && (
              <span>
                <span>{p.name}</span>
                <span
                  className={
                    css.InputPaymentMySubscription__PurchaseProductLimit
                  }
                >
                  {intl.formatMessage(
                    {
                      id: 'books.paymentMethod.booking_limit',
                    },
                    {
                      remain: p.booking_limit.per_month.remain,
                      total: p.booking_limit.per_month.total,
                    },
                  )}
                </span>
              </span>
            )}
            {p.available && !p.booking_limit.limited && <span>{p.name}</span>}
            {!p.available && (
              <span className={css.InputPaymentMySubscription__Disabled}>
                {`${p.name} (${intl.formatMessage({
                  id: 'books.paymentMethod.setting_limit_exceeded',
                })})`}
              </span>
            )}
            {/* 有効期限は月謝の状態にかかわらず表示させるため、p.availableがtrueの条件にしない */}
            {p.expires_at && (
              <span className={css.InputPaymentMySubscription__ExpiresAt}>
                {intl.formatMessage(
                  {
                    id: 'books.paymentMethod.expiresAt',
                  },
                  {
                    expiresAt: dayjs(p.expires_at)
                      .tz('Asia/Tokyo')
                      .format('YYYY年M月D日'),
                  },
                )}
              </span>
            )}
          </CheckInput>
        </div>
      ))}
      {isDisplayRetailer && (
        <div className={css.InputPaymentMySubscription__Available}>
          <div className={css.youCanGetFromHere}>
            {intl.formatMessage({
              id: 'books.forms.youGetSubscriptionAndTicket',
            })}
            <br />
            {intl.formatMessage({
              id: 'books.forms.pleaseRefreshBrowser',
            })}
          </div>
          <div className={css.productListWrap}>
            <BookingPurchaseProductList products={products} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InputPaymentMySubscription;
